import { theme } from '@superhi/design'
import styled from 'styled-components'

export const Separator = styled.hr`
  margin: 0;
  height: 1px;
  border: 0;
  background-color: ${theme.colors.GREY_50};
`
